import ReactDOM from "react-dom/client";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "typeface-inter";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store/store";
import "./i18n/i18n"
import AntdLocaleProvider from "./util/AntdLocaleProvider";

const MuiTheme = createTheme({
  palette: {
    primary: {
      main: "#1487CA",
      contrastText: "#ffffff",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "white",
          color: "#304669",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        text: {
          textTransform: "none",
        },
        sizeLarge: {
          width: "180px",
          height: "46px",
          borderRadius: "8px",
        },
        sizeMedium: {
          font: "normal normal normal 14px/22px inter",
          textTransform: "none",
          padding: "8px 16px"
        },
      },
    },
  },
  typography: {
    allVariants: {
      color: "#304669",
    },
    menuItem:{
      color: "#A2A3A3",
      letterSpacing: "0px",
      font: "normal normal normal 14px/19px inter",
      opacity: "1"
    },
    title: {
      color: "#304669",
      letterSpacing: "0.4px",
      font: "normal normal normal 20px/29px inter",
      opacity: "1",
      fontWeight: 500,
    },
    subtitle3: {
      color: "#304669",
      letterSpacing: "0px",
      font: "normal normal normal 16px/19px inter",
      opacity: "1",
      fontWeight: "400",
    },
    link: {
      color: "#304669",
      letterSpacing: "0.4px",
      font: "normal normal normal 16px/19px inter",
      opacity: "1",
      fontWeight: "400",
    },
    subtitle4: {
      color: "#304669",
      letterSpacing: "0.4px",
      font: "normal normal normal 16px/19px inter",
      fontWeight: "400",
      opacity: "0.8",
    },
    label: {
      color: "#304669",
      letterSpacing: "0",
      font: "normal normal normal 14px/26px inter",
      fontWeight: "400",
      opacity: "0.5",
    },
    value: {
      color: "#304669",
      letterSpacing: "0",
      font: "normal normal normal 14px/26px inter",
      fontWeight: "400",
      opacity: "1",
    },
    fieldLabel: {
      color: "#304669",
      font: "normal normal normal 16px/20px inter",
      fontWeight: "400",
      opacity: "1",
    },
    fieldValue: {
      color: "#304669",
      letterSpacing: "0.9px",
      font: "normal normal normal 14px/22px inter",
      fontWeight: "500",
      opacity: "1",
    },
    dropdownLabel: {
      color: "#304669",
      letterSpacing: "0px",
      font: "normal normal normal 12px/20px inter",
      opacity: "1",
      fontWeight: "500",
    },
    accrualBalanceLabel: {
      color: "#141414",
      letterSpacing: "0px",
      font: "normal normal normal 18px/20px inter",
      opacity: "1",
      fontWeight: "600",
    },
    accuruedYear: {
      color: "#141414",
      letterSpacing: "0px",
      font: "normal normal normal 16px/20px inter",
      opacity: "1",
      fontWeight: "400",
    },
    timeOffPlan: {
      color: "#141414B2",
      letterSpacing: "0px",
      font: "normal normal normal 16px/20px inter",
      opacity: "1",
      fontWeight: "400",
    },
    lastPunchLabel1: {
      color: "#141414",
      letterSpacing: "0px",
      font: "normal normal normal 24px/20px inter",
      opacity: "1",
      fontWeight: "600",
    },
    lastPunchLabel2: {
      color: "#141414",
      letterSpacing: "0px",
      font: "normal normal normal 18px/20px inter",
      opacity: "1",
      fontWeight: "400",
    },
    lastPunchLabel3: {
      color: "#141414",
      letterSpacing: "0px",
      font: "normal normal normal 18px/20px inter",
      opacity: "1",
      fontWeight: "600",
    },

    punchInfoCardLabel1: {
      color: "#141414",
      letterSpacing: "0px",
      font: "normal normal normal 12px/20px inter",
      opacity: "1",
      fontWeight: "600",
    },
    punchInfoCardLabel2: {
      color: "#141414",
      letterSpacing: "0px",
      font: "normal normal normal 10px/20px inter",
      opacity: "1",
      fontWeight: "400",
    },

    resetPasswordTittle:{
      color: "#304669",
      letterSpacing: "0px",
      font: "normal normal normal 20px/20px inter",
      opacity: "1",
      fontWeight: "500",
    },
    popoverItems: {
      color: "#304669",
      letterSpacing: "0px",
      font: "normal normal normal 16px/20px inter",
      opacity: "1",
      fontWeight: "400",
    },
    attQuestionTitle: {
      color: "#304669",
      letterSpacing: "0px",
      font: "normal normal normal 18px/20px inter",
      opacity: "1",
      fontWeight: "500",
    },
    attQuestionText: {
      color: "#304669",
      letterSpacing: "0px",
      font: "normal normal normal 16px/20px inter",
      opacity: "1",
      fontWeight: "400",
    },

  },
});
 
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <ThemeProvider theme={MuiTheme}>
     <AntdLocaleProvider>
        <App/>
        </AntdLocaleProvider>
    </ThemeProvider>
    </PersistGate>
  </Provider>
);
